/** Public store listings for Enough (web download prompts, update banners). */
export const ENOUGH_APP_STORE_URL =
  'https://apps.apple.com/us/app/enough-financial-wellness/id6760366924';
export const ENOUGH_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=app.enough';
